// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import StepperContainer from './eventTile/StepperContainer';
import EventDetails from './eventTile/EventDetails';
import EventsShoppingCenterTile from './EventsShoppingCenterTile';
import eventsApi from '../../../../network/api/eventsApi';
import type { ShoppingCenter } from '../../../../types/shoppingCenterType';
import type { Match } from '../../../../types/commonTypes';
import Loader from '../../../common/Loader';
import type { EventTileWithOpeningStore } from '../../../../types/eventType';

type Props = {
  match: Match,
  history: History,
  location: Location,
}
type State = {
  pcId: number,
  countrySc: ShoppingCenter[],
  openingEvent: EventTileWithOpeningStore,
  loadingCenters: boolean,
}

class EventTab extends React.Component<Props, State> {
  state = {
    pcId: null,
    countrySc: null,
    openingEvent: null,
    loadingCenters: false,
  };

  chooseShoppingCenter = (pcId: number) => {
    this.setState({ pcId: pcId });
  };

  cleanURL() {
    this.props.history.push(`${this.props.location.pathname}`);
  }

  fetchSCWithEvents() {
    this.setState({ loadingCenters: true });
    eventsApi.fetchShoppingCenters(this.props.match.params.country)
      .then(response => !!response && response.json())
      .then((countrySc) => {
        this.setState({ countrySc });
      })
      .finally(() => {
        this.setState({
          loadingCenters: false,
        });
      });
  }

  componentDidUpdate(prevProps: Props, prevState: State, s: any) {
    if (prevProps.match.params.country !== this.props.match.params.country) {
      this.chooseShoppingCenter(null);
      this.cleanURL();
      this.fetchSCWithEvents();
    }
  }

  componentDidMount() {
    this.fetchSCWithEvents();
  }

  updateClickedOpeningEvent = (openingEvent: EventTileWithOpeningStore) => {
    this.setState({ openingEvent });
  }

  updateLoadingCenters = (bool: boolean) => {
    this.setState({ loadingCenters: bool });
  }

  render() {
    const { pcId, countrySc, loadingCenters, openingEvent } = this.state;
    return (
      <>
        <div className="event-scrollbar">
          <div className="event-list-sc">
            {
              countrySc
              && countrySc.map((sc, index) => (
                <EventsShoppingCenterTile
                  key={sc.id}
                  sc={sc}
                  index={index}
                  chooseShoppingCenter={this.chooseShoppingCenter}
                  pcId={pcId}
                />
              ))
            }
          </div>
        </div>
        <div className="event-page group-event-page">
          {
            pcId
            && (
              <>
                <div className="timeline">
                  <StepperContainer
                    pcId={pcId}
                    updateIsLoading={this.updateLoadingCenters}
                    updateClickedOpeningEvent={this.updateClickedOpeningEvent}
                  />
                </div>
                <div className="event-content">
                  {
                    loadingCenters
                      ? <Loader isLoading />
                      : <EventDetails openingEvent={openingEvent} />
                  }
                </div>
              </>
            )
          }
        </div>
      </>
    );
  }
}

export default withRouter(EventTab);
